/**
 * PileGame main js file
 * */

/* eslint-disable */
import * as THREE from '../../libs/three/three.module.js'
import threeFun from '../../common/createThree.js'
import TWEEN from '../../libs/tween/tween.esm.js'
import tool from "../../common/tool.js"
export default {
  FACTOR: 0.5,
  MARGIN: 0.05,
  MTL: new THREE.MeshPhongMaterial(),

  drop_height: 5,
  move_factor: 0,

  crash: false,
  changeDirection: 1,
  stackScore: 0,
  box: undefined,
  bBox: undefined,
  s1Box: undefined,
  s2Box: undefined,
  planeUp: undefined,
  planeLow: undefined,
  tween: undefined,
  detectObjects: [],

  // Main function, program entrance
  init () {
    threeFun.init({usePhysic: true}).then(() => {
      this.initSceneConfig() // Config scene
      this.createGround()    // Create the floor
      this.addDetectPlane()  // Create detect plane
      this.loop()            // Loop function
      this.initTween()       // Tween.js animation
      this.initEvent()       // Opera event
      this.replay()
    })
  },
  initSceneConfig () {
    threeFun.renderer.shadowMap.enabled = true
    threeFun.light.castShadow = true
    this.txLoader('assets/three/pileGame/img/wood-2.jpg', this.MTL)
  },
  createGround () {
    let woodMtl = this.getMtl()

    let groundGroup = new THREE.Group()
    groundGroup.name = 'ground'

    let ground = new THREE.Mesh(new THREE.BoxBufferGeometry(60, 1, 60), woodMtl)
    this.enableShadow(ground)
    groundGroup.add(ground)

    let bar = new THREE.Mesh(new THREE.BoxBufferGeometry(2, 3, 62), woodMtl)
    bar.position.y = 2
    this.enableShadow(bar)

    let borderLeft = bar.clone()
    borderLeft.position.x = -31
    groundGroup.add(borderLeft)

    let borderRight = bar.clone()
    borderRight.position.x = 31
    groundGroup.add(borderRight)

    let borderBottom = bar.clone()
    borderBottom.position.z = 30
    borderBottom.rotation.y = THREE.Math.degToRad(90)
    groundGroup.add(borderBottom)

    let borderTop = bar.clone()
    borderTop.position.z = -30
    borderTop.rotation.y = THREE.Math.degToRad(90)
    groundGroup.add(borderTop)

    let baseBox = new THREE.Mesh(new THREE.BoxBufferGeometry(20, 3, 20), woodMtl)
    baseBox.position.y = 2
    baseBox.name = 'baseBox'

    this.addRigidBody(ground, {mass: 0})
    this.addRigidBody(borderBottom, {mass: 0})
    this.addRigidBody(borderRight, {mass: 0})
    this.addRigidBody(borderLeft, {mass: 0})
    this.addRigidBody(borderTop, {mass: 0})
    this.addRigidBody(baseBox, {mass: 0})

    threeFun.scene.add(groundGroup)
    threeFun.scene.add(baseBox)

    this.bBox = baseBox
    this.createMoveBox(this.drop_height)

    console.log(threeFun.scene)
  },
  addDetectPlane () {
    // create a plane for collision detection
    let planeMat = new THREE.MeshBasicMaterial({ color: 0x9090ff, opacity: 0, transparent: true, wireframe: true })

    this.planeUp = new THREE.Mesh(new THREE.PlaneGeometry(59, 59, 10, 10), planeMat)
    this.planeUp.rotation.x = -0.5 * Math.PI
    this.planeUp.position.set(0, 0.6, 0)
    this.planeUp.name = 'detPlaneUp'

    this.planeLow = new THREE.Mesh(new THREE.PlaneGeometry(800, 800, 30, 30), planeMat)
    this.planeLow.rotation.x = -0.5 * Math.PI
    this.planeLow.position.set(0, -0.7, 0)
    this.planeLow.name = 'detPlaneLow'

    threeFun.scene.add(this.planeLow)
    threeFun.scene.add(this.planeUp)
  },
  createMoveBox (high) {
    let mtl = this.getMtl()

    this.box = new THREE.Mesh(new THREE.CubeGeometry(20, 3, 20), mtl)
    this.box.position.y = high
    this.box.name = 'box'
    this.enableShadow(this.box)

    threeFun.scene.add(this.box)
  },
  createDropBox (obj) {
    let {x, y, z} = obj.position
    let mtl = this.getMtl()
    let s2z, s1z, eP, eN, s2pz, s1pz

    // create Mesh and rigid body
    let createRigidBox = (size, pos, objStr, mass) => {
      this[objStr] = new THREE.Mesh(new THREE.CubeGeometry(size.x, size.y, size.z), mtl)
      this[objStr].position.set(pos.x, pos.y, pos.z)
      this[objStr].name = 'box'
      this.enableShadow(this[objStr])
      this.addRigidBody(this[objStr], {mass: mass})
    }

    // handle iteration verse
    let handle = (s1, s2) => {
      this.bBox = s1
      threeFun.scene.add(this.bBox)
      threeFun.scene.add(s2)
      this.box.geometry = s1.geometry.clone()
      this.box.geometry.parameters = {}
      this.box.geometry.parameters.width = s1.geometry.parameters.width
      this.box.geometry.parameters.depth = s1.geometry.parameters.depth
      this.box.geometry.verticesNeedUpdate = true
      this.box.geometry.computeFaceNormals()
    }

    // gameOver
    let gameOverHin = () => {
      document.getElementById('hin').innerText = 'Game Over ! \n Final Score: ' + this.stackScore
      this.createReplayBnt()
      let lastBox = new THREE.Mesh(new THREE.CubeGeometry(this.box.geometry.parameters.width, 3, this.box.geometry.parameters.depth), mtl)
      lastBox.position.set(this.box.position.x, this.box.position.y, this.box.position.z)
      lastBox.name = 'box'
      this.addRigidBody(lastBox)

      threeFun.scene.remove(this.box)
      threeFun.scene.add(lastBox)
    }

    // -- split and create new boxes --

    let slipBoxMap = new Map([
      [ 1, {axis: 'x', side: 'width', anotherAxis: 'z', anotherSide: 'depth', pos: x}], // direction x
      [-1, {axis: 'z', side: 'depth', anotherAxis: 'x', anotherSide: 'width', pos: z}]  // direction y
    ])

    let splitNCreateNewBox = (dir) => {
      let p = slipBoxMap.get(dir)
      s2z = Math.abs(Math.abs(this.bBox.position[p.axis]) - Math.abs(p.pos))    // split box2 width (or depth)  (box2 is the split out box, the other one remain on the stack)
      s1z = this.box.geometry.parameters[p.side] - s2z                             // split box1 width (or depth)
      eN = this.bBox.position[p.axis] - this.bBox.geometry.parameters[p.side] / 2  // edge negative
      eP = this.bBox.position[p.axis] + this.bBox.geometry.parameters[p.side] / 2

      if (s2z > this.bBox.geometry.parameters[p.side]) {
        gameOverHin()
        return
      }

      let addBox = (s2pz, s1pz) => {
        let size = new THREE.Vector3(1, 3, 1)['set' + p.anotherAxis.toUpperCase()](this.bBox.geometry.parameters[p.anotherSide])
        let pos = new THREE.Vector3(x, y, z)

        createRigidBox(size.clone()['set' + p.axis.toUpperCase()](s2z), pos['set' + p.axis.toUpperCase()](s2pz), 's2Box')
        createRigidBox(size.clone()['set' + p.axis.toUpperCase()](s1z), pos['set' + p.axis.toUpperCase()](s1pz), 's1Box', 0)

        handle(this.s1Box, this.s2Box)
      }

      if (this.bBox.position[p.axis] > p.pos) {
        s2pz = eN - s2z / 2 // split box2 position x (or z)
        s1pz = eN + s1z / 2 // split box1 position x (or z)
        addBox(s2pz, s1pz)
      } else if (this.bBox.position[p.axis] < p.pos) {
        s2pz = eP + s2z / 2 // split box2 position x (or z)
        s1pz = eP - s1z / 2 // split box1 position x (or z)
        addBox(s2pz, s1pz)
      }
    }

    splitNCreateNewBox(this.changeDirection)
  },
  dropBox () {
    let hin = document.getElementById('hin')

    if (hin.innerText.slice(0, 11) === 'Game Over !') return

    this.drop_height += 3
    this.createDropBox(this.box)

    if (hin.innerText.slice(0, 11) !== 'Game Over !') {
      this.stackScore++
      hin.innerText = 'Score:' + this.stackScore
    }

    this.box.position.y = this.drop_height
    this.changeDirection *= -1

    threeFun.camera.userData.posY = threeFun.camera.position.y
    threeFun.light.userData.posY = threeFun.light.position.y
    this.tween.start()
  },
  getMtl () {
    return this.MTL
  },
  loop () {
    let rayCaster = new THREE.Raycaster()

    let func = () => {
      TWEEN.update()

      // -- box move --
      if (this.changeDirection === 1) {
        this.box.position.z = this.bBox.position.z
        this.box.position.x = 25 * (Math.cos(this.move_factor))
      } else {
        this.box.position.x = this.bBox.position.x
        this.box.position.z = 25 * (Math.cos(this.move_factor))
      }
      this.move_factor += 0.03

      // --detect collision--
      let originPoint = this.planeUp.position.clone()
      let originPoint2 = this.planeLow.position.clone()

      let detectFunc = (vertex, originPoint) => {
        // 顶点原始坐标
        let localVertex = vertex.clone()
        // 顶点经过变换后的坐标
        let globalVertex = localVertex.applyMatrix4(this.planeUp.matrix)
        let directionVector = globalVertex.sub(this.planeUp.position)

        rayCaster.set(originPoint, directionVector.clone().normalize())
        let collisionResults = rayCaster.intersectObjects(this.detectObjects)
        if (collisionResults.length > 0 && collisionResults[0].distance < directionVector.length()) {
          this.crash = true
          return true
        }
        this.crash = false
        return false
      }

      for (let vertexIndex = 0; vertexIndex < this.planeUp.geometry.vertices.length; vertexIndex++) {
        detectFunc(this.planeLow.geometry.vertices[vertexIndex], originPoint)
      }

      for (let vertexIndex = 0; vertexIndex < this.planeLow.geometry.vertices.length && this.crash === false; vertexIndex++) {
        detectFunc(this.planeLow.geometry.vertices[vertexIndex], originPoint2)
      }

      if (this.crash) {
        console.log('crash!')
        document.getElementById('hin').innerText = 'Crash!'
      }
    }

    threeFun.loopFunc.push(func)
  },
  initEvent () {
    document.getElementById('three').addEventListener('mousedown', () => { this.dropBox() }, false)
  },
  createReplayBnt () {
    let btn = document.getElementById('replay')
    btn.setAttribute('class', 'show')
    btn.addEventListener('mousedown', () => { this.replay() })
  },
  replay () {
    let btn = document.getElementById('replay')
    btn.setAttribute('class', '')
    this.stackScore = 0
    this.drop_height = 5

    threeFun.camera.position.set(55, 39, 55)
    threeFun.camera.lookAt(new THREE.Vector3(8, 0, 8))
    threeFun.light.position.set(20, 100, 50)

    document.getElementById('hin').innerText = 'Score:' + this.stackScore

    let getBox = () => threeFun.scene.getObjectByName('box')
    let box = getBox()
    while (box) {
      threeFun.scene.remove(box)
      box = getBox()
    }

    let dynObjs = threeFun.physic.dynamicObjects
    for (let i = 0; dynObjs.length > i; i++) {
      if (dynObjs[i].name === 'box') {
        let body = dynObjs[i].userData.physicsBody
        threeFun.physic.dynamicObjects.splice(i, 1)
        threeFun.physic.physicsWorld.removeRigidBody(body)
        i--
      }
    }

    this.bBox = threeFun.scene.getObjectByName('baseBox')
    this.createMoveBox(this.drop_height)
  },

  initTween () {
    let addHeightGoal = 3
    let posSrc = {pos: 0}
    this.tween = new TWEEN.Tween(posSrc).to({pos: 3}, 1000)
    this.tween.easing(TWEEN.Easing.Sinusoidal.Out)

    let onUpdate = () => {
      let pos = this.tween._object.pos

      threeFun.camera.position.y = threeFun.camera.userData.posY + pos
      threeFun.light.position.y = threeFun.light.userData.posY + pos

      if (pos === addHeightGoal) {
        threeFun.camera.userData.posY = threeFun.camera.position.y
        threeFun.light.userData.posY = threeFun.light.position.y
      }
    }
    this.tween.onUpdate(onUpdate) // Executed each time the tween is updated, after the values have been actually updated.
  },
  enableShadow (obj) {
    obj.castShadow = true
    obj.receiveShadow = true
  },

  /**
   * Create a rigidBody for obj
   * @param {Object3D} obj
   * @param {Object} option = { mass, friction, restitution }
   * */
  addRigidBody (obj, option = {}) {
    let objSize = obj.geometry.parameters
    let objPos = obj.position
    let size = {x: objSize.width, y: objSize.height, z: objSize.depth}
    let pos = {x: objPos.x, y: objPos.y, z: objPos.z}
    let qua = obj.quaternion.clone()

    let mass = option.mass !== undefined ? option.mass : size.x * size.y * size.z * 0.01
    let friction = option.friction || 0.9
    let restitution = option.restitution || 0.3

    let shape = new Ammo.btBoxShape(new Ammo.btVector3(size.x * this.FACTOR, size.y * this.FACTOR, size.z * this.FACTOR))
    shape.setMargin(this.MARGIN)

    let localInertia = new Ammo.btVector3(0, 0, 0)
    shape.calculateLocalInertia(mass, localInertia)

    let transform = new Ammo.btTransform()
    transform.setIdentity()
    transform.setOrigin(new Ammo.btVector3(pos.x, pos.y, pos.z))
    transform.setRotation(new Ammo.btQuaternion(qua.x, qua.y, qua.z, qua.w))

    let motionState = new Ammo.btDefaultMotionState(transform)
    let rbInfo = new Ammo.btRigidBodyConstructionInfo(mass, motionState, shape, localInertia)
    let body = new Ammo.btRigidBody(rbInfo)

    body.setFriction(friction)
    body.setRestitution(restitution)

    // body.setActivationState( 4 )

    obj.userData.physicsBody = body

    obj.receiveShadow = true
    obj.castShadow = true

    threeFun.physic.dynamicObjects.push(obj)

    threeFun.physic.physicsWorld.addRigidBody(body)
  },
  txLoader(url, mtl){
    let loader = new THREE.TextureLoader()

    let onLoad = tx => {
      mtl.map = tx
      mtl.needsUpdate = true
    }

    let fail = e => {
      console.log('Load texture img fail: ', e)
    }

    loader.load(url, onLoad, undefined, fail)
  },

}
